import { type GroupWorkoutItemData } from "src/workouts/WorkoutEditStore";

import { FreestyleMediaField } from "./FreestyleMediaField";
import { InstructionsField } from "./InstructionsField";
import { SectionFieldsContainer } from "./SectionFieldsContainer";

interface FreestyleSectionFieldsProps {
  workoutItem: GroupWorkoutItemData;
  onUpdate: (updates: Partial<GroupWorkoutItemData>) => void;
}

export function FreestyleSectionFields(props: FreestyleSectionFieldsProps) {
  function handleStopPropagation(e: React.MouseEvent) {
    e.stopPropagation();
  }

  return (
    <SectionFieldsContainer onClick={handleStopPropagation}>
      <InstructionsField
        value={props.workoutItem.instructions}
        onChange={(value) => {
          props.onUpdate({ instructions: value });
        }}
      />
      <FreestyleMediaField
        workoutItemId={props.workoutItem.id}
        videoUrl={props.workoutItem.mediaUrl}
        video={props.workoutItem.media}
        onVideoUrlChange={(value) => {
          props.onUpdate({ mediaUrl: value });
        }}
      />
    </SectionFieldsContainer>
  );
}
